import BundleChildTitle from './BundleChildTitle';

export default BundleChildTitle;
